import React, { useState } from 'react';
import { isPresent } from 'utils/helperMethods';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { appRoutes } from 'routes';

import { Typography } from '@material-ui/core';
import LocationSelectInput from 'sharedComponents/LocationSelectInput';

import LoanOfficerProfileReviewPopup from './components/LoanOfficerProfileReviewPopup';
import LoanOfficersList from './components/LoanOfficersList';

import useStyles from './useStyles';

const LoanOfficerSelect = props => {
  const { location, onSelectLocation, onSelectLoanOfficer } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const [selectedLoanOfficer, setSelectedLoanOfficer] = useState(null);

  const isLocationPresent = isPresent(location);
  const stateCode = isLocationPresent ? location.state : '';
  const defaultInputValue = isPresent(location) ? `${location.city}, ${location.state}` : '';
  const isLoanOfficerSelected = isPresent(selectedLoanOfficer);

  const handleNext = loanOfficer => {
    onSelectLoanOfficer(loanOfficer);
    history.push(appRoutes.loanOfficersSearchSurveyWizardPath());
  };

  const handleLoanOfficerSelect = loanOfficer => {
    setSelectedLoanOfficer(loanOfficer);
  };

  const handleClosePopup = () => {
    setSelectedLoanOfficer(null);
  };

  return (
    <div className={classes.container}>
      <div className={classes.paper}>
        <LocationSelectInput
          onChange={onSelectLocation}
          searchIcon
          defaultInputValue={defaultInputValue}
          className={classes.select}
        />

        {isLocationPresent ? (
          <div className={classes.listBox}>
            <Typography variant="h2" className={classes.header}>
              {t('components.BuyerLoanOfficerSearchSurvey.LoanOfficerSelect.header')}
            </Typography>
            <LoanOfficersList stateCode={stateCode} onLoanOfficerSelect={handleLoanOfficerSelect} />
          </div>
        ) : (
          <div className={classes.informer}>
            <Typography variant="subtitle1">
              {t('components.BuyerLoanOfficerSearchSurvey.LoanOfficerSelect.selectLocation')}
            </Typography>
          </div>
        )}
      </div>
      {isLoanOfficerSelected && (
        <LoanOfficerProfileReviewPopup
          onClose={handleClosePopup}
          onNext={handleNext}
          loanOfficer={selectedLoanOfficer}
        />
      )}
    </div>
  );
};

LoanOfficerSelect.propTypes = {
  location: PropTypes.shape(),
  onSelectLocation: PropTypes.func.isRequired,
  onSelectLoanOfficer: PropTypes.func.isRequired,
};

LoanOfficerSelect.defaultProps = {
  location: {},
};

export default LoanOfficerSelect;



// WEBPACK FOOTER //
// ./src/components/BuyerLoanOfficerSearchSurvey/components/LoanOfficerSelect/LoanOfficerSelect.js